import type { Order, OrderHistory, OrderRevisionNote, OrderRouteCity } from "./order";
import { mapOrderResponse } from "./order";

export enum SuratJalanStatus {
  IN_REVIEW = "in_review",
  INVOICING_REVIEW = "invoicing_review",
  REVISION_REQUIRED = "revision_required",
  APPROVED = "approved",
}

export interface SuratJalanOrderSummary {
  _id: string;
  readableId: string;
  status: string;
  externalOrderId?: string;
  departureTimestamp?: string;
  customer: { _id: string; name: string } | null;
  truck: { _id: string; licensePlate: string } | null;
  teamOperations: { _id: string; name: string } | null;
  load: OrderRouteCity[];
  unload: OrderRouteCity[];
}

export interface SuratJalanListItem {
  _id: string;
  readableId: string;
  companyId: string;
  teamOperationsId: string;
  orderId: string;
  uangJalanReportId: string;
  status: SuratJalanStatus;
  revisionNote?: OrderRevisionNote;
  createdAt: string;
  order: SuratJalanOrderSummary | null;
}

export interface SuratJalanDetail extends Omit<SuratJalanListItem, "order"> {
  order: Order | null;
  uangJalanReport: { readableId: string; status: string } | null;
  histories: OrderHistory[];
}

export interface SuratJalanSearchFilters {
  status?: string;
  statuses?: string[];
  teamOperationsId?: string;
  actionRequired?: boolean;
}

export const isSuratJalanApproved = (status: SuratJalanStatus | string): boolean =>
  status === SuratJalanStatus.APPROVED;

const mapListItem = (response: any): SuratJalanListItem => ({
  _id: response._id,
  readableId: response.readableId,
  companyId: response.companyId,
  teamOperationsId: response.teamOperationsId,
  orderId: response.orderId,
  uangJalanReportId: response.uangJalanReportId,
  status: response.status,
  revisionNote: response.revisionNote,
  createdAt: response.createdAt,
  order: response.order ?? null,
});

export const mapSuratJalanListResponse = (response: any): SuratJalanListItem[] => {
  const rows = response?.data?.suratJalans ?? [];
  return rows.map(mapListItem);
};

export const mapSuratJalanDetailResponse = (response: any): SuratJalanDetail => {
  const item = response?.data?.suratJalan ?? response;
  return {
    ...mapListItem(item),
    order: item.order ? mapOrderResponse(item.order) : null,
    uangJalanReport: item.uangJalanReport ?? null,
    histories: item.histories ?? [],
  };
};
